import type { State } from './reducer'
import type { ActionsNetwork } from 'shared/store/actions'
import type { ActionDashboardDataResponse } from 'shared/store/kingdom/dashboard'
import { actionNetworkError, fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import type { Dispatch } from 'redux'
import { ws } from 'shared/store/ws'
import { errors } from 'shared/utils'

const { page, wallet } = endpoints.kingdom.card

type ActionCardDataResponse = {
    type: 'PAGE_DATA_CARD_RESPONSE',
    data: State
}

type ActionCardLogout = {
    type: 'LOGOUT'
}

type ActionCardSigninSend = {
    type: 'SIGNIN_SEND_FORM_SUCCESS'
}

type ActionCardSigninSocial = {
    type: 'SOCIAL_PENDING'
}

type ActionCardSignupSend = {
    type: 'SIGNUP_SEND_FORM_SUCCESS'
}

type ActionCardError = {
    type: 'CARD_ERROR',
    cardError: boolean
}

const fetchCardPageData = () => fetchPageData(page, 'PAGE_DATA_CARD_RESPONSE')

const actionError = (cardError: boolean): ActionCardError => ({
    type: 'CARD_ERROR',
    cardError
})

const getWallet = () => async (dispatch: Dispatch<any>) => {
    try {
        const response = await ws.get(wallet)
        dispatch(actionError(false))
        return response.data && response.data.wallet
    } catch (error) {
        console.error('Error getting wallet in card page', error)
        switch (error) {
            case errors.NETWORK:
                dispatch(
                    actionNetworkError({
                        type: errors.NETWORK
                    })
                )
                break
            case errors.TIMEOUT:
                dispatch(
                    actionNetworkError({
                        type: errors.TIMEOUT
                    })
                )
                break
            default:
                dispatch(actionError(error))
                break
        }
        return false
    }
}

export { actionError, fetchCardPageData, getWallet }

export type Action =
    | ActionCardDataResponse
    | ActionCardLogout
    | ActionCardSigninSend
    | ActionCardSigninSocial
    | ActionCardSignupSend
    | ActionCardError
    | ActionDashboardDataResponse
    | ActionsNetwork
